import { Heading } from "@chakra-ui/react";
import { CreateResidenceTypeModal } from "../../components/modals/CreateResidenceTypeModal";
import { ResidenceTypeTable } from "../../components/ResidenceTypeContent/ResidenceTypeTable";

export function ResidenceTypeListPage() {
  return (
    <>
      <Heading as="h1" mb="4">
        Woningtypen
      </Heading>
      <CreateResidenceTypeModal />
      <ResidenceTypeTable />
    </>
  );
}
